import {cz} from './translations/cz';
import {de} from './translations/de';
import {en} from './translations/en';
import {es} from './translations/es';
import {fr} from './translations/fr';
import {it} from './translations/it';
import {lt} from './translations/lt';
import {lv} from './translations/lv';
import {nl} from './translations/nl';
import {pl} from './translations/pl';
import {pt} from './translations/pt';
import {ru} from './translations/ru';
import {ua} from './translations/ua';

export const translations = {
  cz: cz, 
  de: de,
  en: en,
  es: es,
  fr: fr,
  it: it,
  lt: lt,
  lv: lv,
  nl: nl,
  pl: pl,
  pt: pt,
  ru: ru,
  ua: ua
}